/**
 * JournalPage.jsx — Phase 7 (ENHANCED)
 *
 * Write tab: ImmersiveDiary (world-class writing experience)
 * Entries tab: DiaryVault.jsx (preserved)
 * Reports tab: Insight.jsx (preserved)
 */

import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ImmersiveDiary from "../components/ImmersiveDiary";
import DiaryVault from "../../pages/DiaryVault";
import Insight from "../../pages/Insight";

const TABS = [
  { id: "write",   emoji: "📓", label: "Write" },
  { id: "entries", emoji: "📖", label: "Entries" },
  { id: "reports", emoji: "📊", label: "Reports" },
];

export default function JournalPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("write");

  const handleEntrySaved = useCallback(() => {
    setTimeout(() => setActiveTab("entries"), 2500);
  }, []);

  return (
    <div className="hh-journal-page">
      <header className="hh-journal-header">
        <button className="hh-journal-back" onClick={() => navigate("/dashboard")} aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span className="hh-journal-title">Journal</span>
        <div style={{ width: 32 }} />
      </header>

      <div className="hh-journal-tabs">
        {TABS.map(t => (
          <button key={t.id}
            className={`hh-journal-tab${activeTab === t.id ? " active" : ""}`}
            onClick={() => setActiveTab(t.id)}>
            {t.emoji} {t.label}
          </button>
        ))}
      </div>

      <div className="hh-journal-content">
        {activeTab === "write" && (
          <div className="hh-journal-section" key="write">
            <ImmersiveDiary onEntrySaved={handleEntrySaved} />
          </div>
        )}
        {activeTab === "entries" && (
          <div className="hh-journal-section" key="entries">
            <div className="hh-journal-component-wrap">
              <DiaryVault />
            </div>
          </div>
        )}
        {activeTab === "reports" && (
          <div className="hh-journal-section" key="reports">
            <div className="hh-journal-component-wrap">
              <Insight />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}